<template>
  <div
    class="text-image-block overflow py-4 md:py-8"
    :class="[model.background, model.textColor ? model.textColor : 'text-[color:var(--color-body-text)]']"
  >
    <div class="container mx-auto max-w-screen-xl">
      <div
        class="mx-auto flex w-full flex-col md:flex-row"
        :class="[model.imagePosition === `right` ? `md:flex-row-reverse` : ``]"
      >
        <div
          class="mb-6 flex aspect-video flex-1 flex-col items-start justify-center md:mb-0"
          :class="[model.imagePosition === `right` ? `md:items-end` : `md:pr-8`]"
        >
          <div class="w-full overflow-hidden rounded-xl">
            <img :src="model.image" class="w-full object-cover" alt="" />
          </div>
        </div>
        <div class="flex flex-1 flex-wrap items-center">
          <div class="md:max-w-md">
            <VcTypography :tag="model.heading" v-if="model.title" class="mb-2">
              {{ model.title }}
            </VcTypography>
            <div v-if="model.text" class="block-content mb-6 text-lg" v-html-safe="model.text"></div>

            <template v-if="model.buttonExternalUrl">
              <VcButton
                is="a"
                v-if="showTheButton"
                :external-link="model.buttonUrl"
                target="_blank"
                class="w-auto px-8"
              >
                {{ model.buttonLabel }}
              </VcButton>
            </template>

            <template v-else>
              <VcButton v-if="showTheButton" :to="model.buttonUrl" class="w-auto px-8">
                {{ model.buttonLabel }}
              </VcButton>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps({
  model: {
    type: Object,
    required: true,
  },
});

const showTheButton = computed(() => {
  return Boolean(props.model.buttonLabel) && Boolean(props.model.buttonUrl);
});
</script>

<style lang="scss" scoped></style>
